import { ActiveState, EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { GetBulkChangeBillingRunsRequest, BulkChangeBillingRun } from './bulk-change-billing.model';
import { PaginationState } from '@lib/state';
import { BulkChangeBillingPreviewResponse } from '@lib/state/api/generated/reservations';

export interface BulkChangeBillingState
  extends EntityState<BulkChangeBillingRun, BulkChangeBillingRun['id']>,
    ActiveState<BulkChangeBillingRun['id']> {
  ui: GetBulkChangeBillingRunsRequest;
  pagination: PaginationState;
  preview?: BulkChangeBillingPreviewResponse;
  pendingRunId?: string;
}

@StoreConfig({ name: 'bulk-change-billing', resettable: true })
export class BulkChangeBillingStore extends EntityStore<BulkChangeBillingState> {
  constructor() {
    super({
      ui: {},
      pagination: {
        isDone: true,
        continuationToken: undefined,
      },
      loading: false,
      preview: undefined,
      pendingRunId: undefined,
    });
  }
}

let _bulkChangeBillingStore: BulkChangeBillingStore;

export function getBulkChangeBillingStore(): BulkChangeBillingStore {
  if (!_bulkChangeBillingStore) {
    _bulkChangeBillingStore = new BulkChangeBillingStore();
  }
  return _bulkChangeBillingStore;
}
